<template>
<v-container fluid>
  <v-row>





    <v-col cols="12">
    <v-card>
        <v-btn @click="generateIt()">
          Generate
        </v-btn>
        {{ nlp_result }}
        <v-toolbar
          dense
          flat
        >
          Named Entity Filters
        </v-toolbar>





        <v-card-text>

            <v-chip-group
              column
              multiple
              @change="filterEntities($event)"
            >
              <v-chip filter outlined :color="color_type['PERSON']">PERSON</v-chip>
              <v-chip filter outlined :color="color_type['ORGANIZATION']">ORGANIZATION</v-chip>
              <v-chip filter outlined :color="color_type['DATE']">DATE</v-chip>
              <v-chip filter outlined :color="color_type['QUANTITY']">QUANTITY</v-chip>
              <v-chip filter outlined :color="color_type['EVENT']">EVENT</v-chip>
            </v-chip-group>


            <v-switch
            v-model="switchPhrase"
            label="Show in Context"
          ></v-switch>

          <v-switch
          v-if="switchPhrase"
          v-model="showDetailedInfo"
          label="Show Details"
        ></v-switch>

      </v-card-text>




      </v-card>
    </v-col>




    <v-col md="12" sm="12" xs="12" cols="9" v-if="!switchPhrase">
      <div v-for="(entitytype, entitytype_index) in Object.keys(all_phrases)"
           :key="entitytype_index"
      >
      <v-card class="mb-6">
        <v-card-title>
          {{ entitytype }}
        </v-card-title>
        <v-card-text>
          <v-chip-group
            active-class="primary--text"
            column
          >
            <v-chip small v-for="(entity, entityindex) in all_phrases[entitytype]" :key="entityindex"
              :color="color_type[entitytype]"
              style="color:white;font-weight:600;"
            >
              {{ entity }}
            </v-chip>
          </v-chip-group>
        </v-card-text>
      </v-card>
      </div>

    </v-col>
    <v-col md="12" sm="12" xs="12" cols="9" v-else>
      <v-card style="overflow-y: auto;" height="800">
        <v-card-text>

      <v-timeline dense>

          <v-timeline-item
            v-for="(chunk, chunk_index) in display_chunks.filter(x=>x.entity_types.length >0)"
            :key="chunk_index"
            right
          >

          <v-row class="pt-1" align="center">
            <v-col cols="2" v-if="showDetailedInfo">
              <strong>{{ chunk.speaker }}</strong>
            </v-col>
            <v-col>


            <v-card class="elevation-2">
              <v-card-title class="headline">
                <v-chip-group
                  active-class="primary--text"
                >
                  <v-chip v-for="entity_type in chunk.entity_types" :key="entity_type">
                    {{ entity_type }}
                  </v-chip>
                </v-chip-group>
              </v-card-title>
              <v-card-text>
                <v-textarea
                  v-html="chunk.text"
                  outlined
                  dense
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      </v-card>

    </v-col>




  </v-row>

</v-container>

</template>

<script>
import { getEntities } from '../entities-example.js';

export default {
  name: 'ShuttleNamedEntities',

  data() {
    return {
      entityColors: {
        PERSON: '',
        NORP: '',
        FAC: '',
        ORG: '',
        LOC: '',
        GPE: '',
        PRODUCT: '',
        EVENT: '',
        WORK_OF_ART: '',
        LAW: '',
        LANGUAGE: '',
        DATE: '',
        TIME: '',
        PERCENT: '',
        MONEY: '',
        QUANTITY: '',
        ORDINAL: '',
        CARDINAL: ''
      },







      nlp_result: [],
      showDetailedInfo: false,
      all_phrases: {
        "ORGANIZATION": [],
        "PERSON": [],
        "DATE": [],
        "QUANTITY": [],
        "EVENT": []
      },
      switchPhrase: false,
      text_chunks: [],
      display_chunks: [],
      textarea: "",
      exampledata:[],
      entities: [
        'PERSON', 'ORGANIZATION', 'EVENT', 'TITLE', 'DATE', 'QUANTITY'
      ],
      color_type: {
        "ORGANIZATION": '#ba55d3',
        "PERSON": '#dd7e91',
        "DATE": "#55d37b",
        "QUANTITY": "#d37b55",
        "EVENT": '#d3556e'
      },
      selection: 'Person',
      select: { state: 'Speaker 1', abbr: 'spk_0' },
      items: [
        { state: 'Speaker 1', abbr: 'spk_0' },
        { state: 'Speaker 2', abbr: 'spk_1' },
        { state: 'Speaker 3', abbr: 'spk_2' }
      ],
    }
  },


  mounted() {

    this.text_chunks = getEntities();
    //console.log("ENTITIES");




    this.displayTextChunks();

  },


  methods: {

    async generateIt() {
      let postdata = {transcript_key: this.$store.state.currentShuttle.transcriptPath.slice(1)};
      //console.log(this.$store.state.currentShuttle);
      //console.log(postdata);
      let transcriptresponse = await this.getData(this.$store.state.currentShuttle.transcriptPath,'get',null,this.$store.state.uri.app_base_uri);
      //console.log(transcriptresponse);
      // returns results.transcripts array
      //let resp = await this.postData(this.$store.state.endpoint.post_nlp, postdata);



    },

    filterEntities(new_entities) {
      //console.log(new_entities)
    },

    displayTextChunks() {
      var self = this;
      let color_type = {
        "ORGANIZATION": '#ba55d3',
        "PERSON": '#dd7e91',
        "DATE": "#55d37b",
        "QUANTITY": "#d37b55",
        "EVENT": '#d3556e'
      };

      for (var i = 0; i < this.text_chunks.length; i++) {
        let new_chunk = {};
        new_chunk.entities = this.text_chunks[i].Entities.map(x => x.Text);
        new_chunk.entity_types = [...new Set(this.text_chunks[i].Entities.map(x => x.Type))];
        new_chunk.speaker = this.text_chunks[i].speaker;


        let chunk_text = this.text_chunks[i].chunkText;
        this.text_chunks[i].Entities.forEach(function(entity) {
          let substr = entity.Text;
          if (self.all_phrases[entity.Type]) {
            self.all_phrases[entity.Type].push(entity.Text);
          }

          let htmlsubstr = '<span style="font-weight:600;color:'+color_type[entity.Type]+';">' + substr + '</span>';
          chunk_text = chunk_text.replace(substr, htmlsubstr);
        });

        new_chunk.text = '<span>' + chunk_text + '</span>';
        this.display_chunks.push(new_chunk);
      }

      //console.log(this.display_chunks);





    },



  },


}

</script>
